import 'lazysizes';
import 'picturefill';
import 'ion-rangeslider';
import 'select2';
import 'jquery-countdown';
//import search from './open-search-motor-mobile';
//import modal from '../modules/modal';
import modalFunding from '../modules/modal-infos-funding';
import '../common/SwitchButton.plugin';
import $ from "jquery";

$(document).ready(function () {
    //modal();
    //modalFunding();
    //switchPriceMensuality();
    //search();

    $('.criteria-wrapper >label a').on("click", function () {
        $(this).text(function(i, text){
            return text === "Plus de critères" ? "Moins de critères" : "Plus de critères";
        })
        $('.criteria-wrapper >label').toggleClass('boxShadow');
    })

    $('.btn-select').on("click", function () {
        $(this).find('i').toggleClass('icon-chevron-down1 icon-chevron-up');
    })

    $.each($('.item-card--promo'), function(i,e) {
        var link = $(e).find('a').attr('href');
        $(e).on('click', function(elem) {
            window.location = link;
        });
    });

    function switchPriceMensuality() {
        var $switch = $('input[name="switchPricesListann"]');
        if ($switch.length) {

            if ($switch.is(':checked')) {
                switchToggle();
            }

            $switch.click(function () {
                switchToggle();
                resetToggle();
            });
        }
    }

    function switchToggle() {
        $('.switch').parent().find('.tabPrices').toggleClass('hidden');
        $('.switch').parent().find('.tabMensuality').toggleClass('active');
    }

    function resetToggle() {
        $('.switch').parent().find('.tabPrices').find('select').val(null).trigger("change");
        $('.switch').parent().find('.tabMensuality').find('select').val(null).trigger("change");
    }

    if($('[data-flash-sales-end-date]').length > 0) {
        $('#flash-sales-counter-days').countdown( $('[data-flash-sales-end-date]').data('flash-sales-end-date'))
            .on('update.countdown', function (event) {
                $(this).html(event.strftime('%D'));
            });

        $('#flash-sales-counter-hours').countdown( $('[data-flash-sales-end-date]').data('flash-sales-end-date'))
            .on('update.countdown', function (event) {
                $(this).html(event.strftime('%H'));
            });

        $('#flash-sales-counter-minutes').countdown( $('[data-flash-sales-end-date]').data('flash-sales-end-date'))
            .on('update.countdown', function (event) {
                $(this).html(event.strftime('%M'));
            });

        $('#flash-sales-counter-seconds').countdown( $('[data-flash-sales-end-date]').data('flash-sales-end-date'))
            .on('update.countdown', function (event) {
                $(this).html(event.strftime('%S'));
        });
    }

    // Ouverture de la modal
    $('.modal').appendTo("body");

    $('.box-auto-i-div').on('click', function(e) {
        e.stopPropagation();
    })

    //voir plus / moins texte seo marque / model au dessus des listes
    if ($('.vehicle-list_seo-before_see-more')) {
        $('.vehicle-list_seo-before_see-more').on('click', function(e) {
            $(this).parent().toggleClass('max');
            if ($(this).parent().hasClass('max')) {
                $(this).text('(voir moins)')
            } else {
                $(this).text('(voir plus)')
            }
        })
    }

});



// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/vehicle/listann.js